import React, { useState, useEffect } from "react";
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import {
  InteractionType,
} from "@azure/msal-browser";
import { loginRequest } from "../authConfig";
// Sample app imports
import { UserManagement as UserDataGrid } from "../components/User/UserManagement";
import { Loading } from "../components/Loading";
import { ErrorComponent } from "../components/ErrorComponent";
import { api_path } from "../shared";
const UserContent = () => {
  return <UserDataGrid />;
};

export function UserManagement() {
  const authRequest = {
    ...loginRequest,
  };
  const [getUserRole, setUserRole] = useState();
  const [getUserID, setUserID] = useState();
  const [getUserEMail, setUserEmail] = useState("");
  const { accounts } = useMsal();
  useEffect(() => {
    setUserEmail(accounts[0]?.username);
    fetchUserRole(accounts[0]?.username);
   
  });
  function fetchUserRole(userEmail) {
    fetch(api_path + "/USER_ROLE.php?USER_EMAIL=" + userEmail)
      .then((res) => res.json())
      .then((res) => {
        const array = res;
        for (const i of array) {
          setUserRole(i.USER_ROLE_ID);
          setUserID(i.CRM_UID);
        }
      });
  }
  useEffect(() => {
    var data = {
      ROLE_ID: getUserRole,
      USER_EMAIL: getUserEMail,
      MENU_URL:window.location.pathname,
    };
    fetch(api_path + "/MS_MENU.php", {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result["status"] == "200") {
          window.location = "/s-crm/Home?status=denined";
        }
      });
    // });
  }, [getUserRole]);
  return (
    <MsalAuthenticationTemplate
    interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      <getAccount />
      <UserContent />
    </MsalAuthenticationTemplate>
  );
}
